import TimeItem from './TimeItem';

const GridTimeBox = ({ times }) => {
    return <>{times && times.map((time, index) => <TimeItem key={index} time={time} />)}</>;
};

export default GridTimeBox;
